var app = angular.module('leonardo');

var ValidFields = function () {
  return function (options, id, rule) {
    var array = [];
    var invalidFields = [
      'sectionDivider',
      'pageBreak',
      // 'propertyName',
      // 'propertyAddress',
      // 'propertyInfo',
      'userName',
      // 'unitNumber',
      // 'unitBuilding',
      // 'unitInfo'
    ];
    if (rule) {
      invalidFields = invalidFields.concat(['fileImageInput', 'fileInput', 'imageInput', 'imageMultipleInput', 'signatureInput']);
    }
    angular.forEach(options, function(option) {
      if (option.id !== id && !_.contains(invalidFields, option.component)) {
        if (option.conditions && !rule) {
          var exist = false;
          angular.forEach(option.conditions, function(condition) {
            if (condition.condition_field === id){
              exist = true;
            }
          });
          if (!exist) {
            array.push(option);
          }
        }
        else {
          array.push(option);
        }
      }
    });
    return array;
  };
};

app.filter('validFields', [ValidFields]);
